module.exports = __webpack_public_path__ + "img/icon-heart-fill.c991ec83.svg";